import React from 'react';
import {View} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.clientSearch');

  return (
    <View>
      <Gutter style={styles.headerContainer}>
        <Text variant="heading" style={styles.header}>
          {tt('title', 'Order History')}
        </Text>
      </Gutter>
      <View style={styles.order}>
        <View style={styles.orderLine1}>
          <View style={styles.orderDate}>
            <LoadingBox style={styles.loadingBoxOrderDate} />
            <LoadingBox style={styles.loadingBoxOrderNumber} />
          </View>
          <View style={styles.orderAmount}>
            <LoadingBox style={styles.loadingBoxOrderTotal} />
          </View>
        </View>
      </View>
    </View>
  );
};
